import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Input } from 'react-chat-elements';
import { useSelector, useDispatch } from 'react-redux';
import { connectSocket } from '../../../constants/socketClient';
import { getLocalStorageItem, popup } from '../../../utils';
import { LOCAL_STORAGE, ROLES } from '../../../constants';
import { addMessage, deleteMessage } from '../../../redux';
import { sendMessageAPI } from '../../../utils/apiServices/chatsAPI';

const ChatFooter = () => {
    const dispatch = useDispatch();
    const currentUser = useSelector((s) => s.chat?.selectedUser);
    const role = useSelector((s) => s.user.role);
    const senderName = useSelector((s) => s.user.fullName);
    const csmCaseloadData = useSelector((s) => s.csmCaseload?.csmCaseloadData);
    const userId = csmCaseloadData?.id || getLocalStorageItem(LOCAL_STORAGE.USER_ID);

    const sendMessage = async (text) => {
        let id = uuidv4();
        const trimmedText = text?.trim();
        if (!trimmedText) return;
        const msg = {
            id,
            position: 'right',
            type: 'text',
            text,
            date: new Date(),
            title: senderName,
        };
        // const socket = getSocket();
        const socket = connectSocket(userId);
        socket.emit('send-message', {
            id,
            chat_id: currentUser.chat_id,
            sender: userId,
            sender_name: senderName,
            sender_role: role,
            receiver_role: 'user',
            receiver_name: currentUser.alt,
            receiver_email: currentUser.user_email,
            receiver: role === ROLES.USER ? currentUser.management_id : currentUser.user_id,
            message: trimmedText,
        });
        dispatch(addMessage(msg));
        try {
            await sendMessageAPI({
                id: id,
                chat_id: currentUser.chat_id,
                sender_id: userId,
                message: trimmedText,
            });
        } catch (error) {
            setTimeout(() => dispatch(deleteMessage(id)), 700);
            popup('error', 'Error sending message');
        }
    };

    return (
        <div className='chat-footer'>
            <Input
                placeholder='Type a message...'
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        sendMessage(e.target.value);
                        e.target.value = '';
                    }
                }}
                multiline={false}
                autofocus
            />
        </div>
    );
};

export default ChatFooter;
